module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAP5JREFUOE/V0jFOwzAUxvHvszkHF+jQCQaU9BydUBJ1QLCAWIo6QAFVZOkGC3ICEuIgdQVCrJwG4TwUZhrbUCHhA/z8/s8m1ny4Zg9/CJ6JSjaxtSz4ElOxcsL0XrbFuWdFTha5vgpFO5PT2h0CKAmchqLeHQ5qNxZgGop6wTY1Bg0CY9Bg8As1bizEBZXsLbIN891DRYFpLUNI8wCitLme/Aoc3H3sNsJbAo82UwVI+TGYVjISNNckKpup/VVYe4E3OTHugApzADc210e+D94JJsYdQ2EGYL7M9YkP65wwMe99Ur0CvLSFPg/BupNFuGPQexrxLRQL2mEM9j/AT8V0VRU7ScJHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_arrow_blue.png
// module id = C7W9
// module chunks = 1